import React from 'react';
import { PlayNavigationGenre } from './GenrePageHeader.styles';
import MissingContent from '../../ui-components/MissingContent/MissingContent';

const GenrePageHeader = ({ tabs, selectedTab, location }) => {
    if (tabs.length === 0 || (tabs.length === 1 && tabs[0].selections.length === 0)) {
        return <MissingContent />;
    }

    if (tabs.length === 1) {
        return null;
    }

    return <PlayNavigationGenre selectedTab={selectedTab} tabs={tabs} location={location} />;
};

export default GenrePageHeader;
